import * as PIXI from 'pixi.js';
//@ts-ignore
import store from '../../../../store';
import MessageHelper from '../../../../helpers/MessageHelper';
//@ts-ignore
import {DropShadowFilter, GlowFilter, OutlineFilter} from 'pixi-filters';
import PixiCard from './pixi/PixiCard';
import PixiPile from './pixi/PixiPile';
import PixiHand from './pixi/PixiHand';
import PixiTable from './pixi/PixiTable';
import PixiMessenger from './pixi/PixiMessenger';
import PixiSelector from './pixi/PixiSelector';
import PixiMouse from './pixi/PixiMouse';
import PixiPieMenu from './pixi/PixiPieMenu';
import PixiType from './pixi/PixiType';
import PixiDebug from './pixi/PixiDebug';
import PixiVideoContainer from './pixi/PixiVideoContainer';

import EventApi from '../../../../api/EventsApi';
import {CardPositionDiff, FieldState, Player, StackSetup} from '../../../../../types';
import PixiUtil from './pixi/PixiUtil';
import MState from './pixi/model/MState';
import {IPileM} from './pixi/model/MTypes';
import Painter from './pixi/paint/Painter';
import AutomationCodes from '../../../../../enums/automation-codes/AutomationCodes';

interface ICard
{
    backface_src: string;
    face_src: string;
    flipped: boolean;
    id: number;
    title: string;
    width: number;
    height: number;
    type: number;
}

interface IPosition
{
    cardId: number | string;
    pileId: number | string;
    x: number;
    y: number;
    zone: string;
}

const TWEEN = require('@tweenjs/tween.js');

type GameObject = PIXI.Sprite | PIXI.Container | undefined;

export default class PixiScene
{
    public static readonly testMode: boolean = false;
    public static firstTime: boolean = true;
    /**
     * Получение инстанса пикси
     */
    private static self: PixiScene | undefined;
    public readonly platform = navigator.platform.toUpperCase();
    public debugBox = new PixiDebug(this);
    public painter: Painter | null = null;
    public topContainer = new PIXI.Container;
    public videoContainer: PixiVideoContainer | null = null;
    public tableContainer: PixiTable;
    public handContainer: PixiHand;
    public pixiMouse: PixiMouse;
    public playerId: string = '';
    public players: Array<Player> = [];
    public cardMap = new Map();
    public pileMap = new Map();
    public rect: DOMRect | undefined;
    public pixiRect: PIXI.Rectangle = PIXI.Rectangle.EMPTY;
    public gameField: any;
    public gameState: any;
    public playerColor: number = 0;
    public playerColorCode: string = '#000000';
    public handShift: number = 0;
    public dropShadowFilter = new DropShadowFilter();
    public outlineFilter = new OutlineFilter();
    public glowFilter = new GlowFilter();
    public bottomOverHand: boolean = false;
    private readonly NEW_DIFF_ON = true;
    private readonly app: PIXI.Application | undefined;
    private readonly mat = new PIXI.Sprite(PIXI.Texture.WHITE);
    private readonly translations: {[key: string]: string};
    private isAdmin: boolean = false;
    private tableMask = new PIXI.Graphics();
    private handMask = new PIXI.Graphics();
    private tableBorder = new PIXI.Graphics();
    private pieMenu: PixiPieMenu;
    private hoverTarget: GameObject;
    private hoverTargetT: GameObject | null = null;
    private selectedTarget: GameObject;
    private delta = {x: 0, y: 0};
    private dragStart = {x: 0, y: 0};
    private clearField: boolean = false;
    private isAnimating: boolean = false;
    private isDragFlip: boolean = false;
    private isDragging: boolean = false;
    private isGuest: boolean = false;
    private isHovering: boolean = false;
    private soloDrag: boolean = false;
    private isLocked: boolean = false;
    private isOverHand: boolean = false;
    private isRestarting: boolean = false;
    private isTicking: boolean = false;
    private isTransformed: boolean = false;
    private mouseOut: boolean = false;
    private mustResize: boolean = false;
    private mustUpdate: boolean = false;
    private tableIsLoaded: boolean = false;
    private buttonsSimilo: boolean = false;
    private isSimiloGM: boolean = false;
    private similoSelected = 0;
    private similoCards: Array<number> = [];
    private modelState: MState;
    private clonedCards: Array<PixiCard> = [];
    private logoPos: {x: number, y: number} | null = null;
    private cardHandIndex = -1;
    private layoutType = 1;
    private videosLength = 0;

    private constructor(rect: DOMRect, isAdmin?: boolean, translations?: {[key: string]: string}) {
        const isMac = this.platform.indexOf('MAC') >= 0;
        console.log('%c ### platform:', 'color: #f0f', this.platform, isMac);
        window.Vue.prototype.$logService.addGameLog('PixiScene: platform.isMac ' + isMac);

        this.modelState = new MState;
        this.rect = rect;
        this.pixiRect = new PIXI.Rectangle(rect.x, rect.y, rect.width, rect.height);
        if (typeof isAdmin !== 'undefined') {
            this.isAdmin = isAdmin;
        }
        if (typeof translations === 'undefined') {
            this.translations = {
                empty_hand: 'Your hand is empty'
            };
        } else {
            this.translations = translations;
        }
        this.app = new PIXI.Application({
            width: rect.width,
            height: rect.height,
            antialias: !isMac,
            backgroundAlpha: 0,
            // backgroundColor: 0x35654d,
            resolution: window.devicePixelRatio || 1
        });
        // console.log('%c ### --->', 'color: #f0f', window.devicePixelRatio, this.app.renderer.screen);
        // console.log('%c ### ===>', 'color: #f0f', this.app.renderer.width, this.app.renderer.height);

        this.app.view.style.display = 'block';
        this.app.view.style.width = rect.width + 'px';
        this.app.view.style.height = rect.height + 'px';

        document.addEventListener('keyup', (e: KeyboardEvent) => {
            e.preventDefault();
            this.onPixiKeyup(e);
        });

        this.app.view.addEventListener('contextmenu', (e: MouseEvent) => {
            e.preventDefault();
        });
        this.app.view.addEventListener('mousewheel', (e: Event) => {
            e.preventDefault();
            const we = e as WheelEvent;
            if (we.deltaY > 0) {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomIn'});
            } else {
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'zoomOut'});
            }
            this.tableContainer.tableChangeZoom(
                we.deltaY > 0 ? '-' : '+',
                {x: we.offsetX, y: we.offsetY}
            );
        });
        this.app.view.addEventListener('mouseout', (e: MouseEvent) => {
            e.preventDefault();
            if (this.app && this.selectedTarget) {
                this.mouseOut = true;
                this.selectedTarget.emit('pointerup');
            }
        });
        this.app.view.addEventListener('mousemove', (e: MouseEvent) => {
            e.preventDefault();
            if (this.app && this.pixiMouse) {
                this.pixiMouse.moveTo(e.offsetX, e.offsetY);
            }
        });

        this.app.stage.interactive = true;
        this.app.stage.hitArea = this.app.renderer.screen;
        if (PixiScene.testMode) {
            this.testAdd();
        }
        PixiMessenger.scene = PixiSelector.scene = this;

        this.tableContainer = new PixiTable(this, {});
        this.handContainer = new PixiHand(this, this.translations);
        this.pixiMouse = new PixiMouse(this);
        this.pieMenu = new PixiPieMenu(this);

        this.gameField = store.getters.getGameField;
        const handler = () => {
            // this.resizeHandler(false);
            this.mustResize = true;
            MessageHelper.sendMessage('getGameField', {});
        };

        const debounce = (func: () => void, delay: number) => {
            let inDebounce: number;
            return function () {
                window.clearTimeout(inDebounce);
                inDebounce = window.setTimeout(func, delay);
            };
        };
        window.addEventListener('resize', debounce(handler, 1000), false);
        if (this.isAdmin) {
            this.resizeHandler(true);
        }

        EventApi.addEventListener(EventApi.UPDATE_SEATS_ON_TABLE, this.updateTableSeats.bind(this));
    }

    public get curPlayerId(): string {
        return store.getters.getPlayerId as string;
    }

    public get curPlayers(): Array<Player> {
        return store.getters.getPlayers as Array<Player>;
    }

    /**
     * Стол запущен в визуальной админке или нет
     */
    public get isInAdminMode(): boolean {
        return this.isAdmin;
    }

    public get hoverId(): number {
        return (this.hoverTarget as PixiCard)?.cardId ?? -1;
    }

    /**
     * Получение вида для вставки в ДОМ
     */
    public get view(): HTMLCanvasElement {
        return this.app!.view;
    }

    /**
     * Проверка особого статуса для игр типа "Мафия"
     */
    public get isMafia(): boolean {
        if (!this.gameState.tasks.state.activity) {
            return false;
        }
        return this.gameState.tasks.state.activity.automation_code === AutomationCodes.MAFIA;
    }

    /**
     * Проверка статуса админа
     */
    public get isAdminStatus(): boolean {
        return this.isAdmin;
    }

    /**
     * Рендерер канваса
     */
    public get renderer() {
        return this.app?.renderer;
    }

    /**
     * Признак загрузки стола
     */
    public get isLoaded() {
        return this.tableIsLoaded;
    }

    public set isLoaded(value: boolean) {
        this.tableIsLoaded = value;
    }

    /**
     * add Similo Button
     */
    public get isSimilo() {
        return this.isSimiloGM ? false : this.buttonsSimilo;
    }

    public static getInstance(rect?: DOMRect, isAdmin?: boolean, translations?: {[key: string]: string}): PixiScene | undefined {
        if (!rect) {
            return PixiScene.self;
        }
        if (!PixiScene.self) {
            PixiScene.self = new PixiScene(rect, isAdmin, translations);
        }
        return PixiScene.self;
    }

    /**
     * Полная очистка
     */
    public clearAll(): void {
        EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER);
        PixiSelector.clearAll();
        this.app?.stage?.removeChildren();
        this.cardMap = new Map();
        this.pileMap = new Map();
        PIXI.utils.clearTextureCache();
    }

    /**
     * Отрисовка при изменении размера окна
     */
    public updateResize(rect: DOMRect): void {
        if (this.app && this.rect) {
            EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER);

            const handContainerVisible = this.handContainer.visible;
            const tableBorderTint = this.tableBorder.tint;
            this.rect = rect;
            this.pixiRect = new PIXI.Rectangle(rect.x, rect.y, rect.width, rect.height);
            this.app.renderer.resize(rect.width, rect.height);
            this.app.view.style.width = rect.width + 'px';
            this.app.view.style.height = rect.height + 'px';
            this.app.stage.hitArea = this.app.renderer.screen;

            PixiSelector.clearAll();
            this.app.stage.removeChildren();
            this.initAll(handContainerVisible, tableBorderTint);
        }
    }

    public updateTableSeats(): void {
        if (this.videoContainer) {
            this.videoContainer.clearAll();
            this.videoContainer = null;
        }

        if (this.layoutType === 5) {
            this.videoContainer = new PixiVideoContainer();
            this.app?.stage.addChild(this.videoContainer);
        }
    }

    /**
     * Цвет рамки стола
     */
    public tableBorderColor(value: number | string): void {
        this.tableBorder.tint = (typeof value === 'number') ? value : parseInt(value.slice(1), 16);
    }

    /**
     * resizeHandler
     */
    public resizeHandler(pageLoader: boolean): void {
        if (pageLoader && !this.isRestarting) {
            this.isRestarting = false;
            this.logoPos = null;
        }
        const el = document.getElementById('tableStageNew');
        if (!!el && el.clientWidth && el.clientHeight && this.rect) {
            EventApi.triggerEvent(EventApi.SHOW_TABLE_LOADER, {stage: this});
            const oldStage = this.tableContainer.stage;
            const oldRect = new DOMRect(0, 0, this.rect.width, this.rect.height);
            this.updateResize(new DOMRect(0, 0, el.clientWidth, el.clientHeight));
            this.tableContainer.resizeRect(oldStage, oldRect, this.rect);
        }
    }

    /**
     * Задать видимость руки (без параметра - переключение)
     */
    public toggleHand(value?: boolean): void {
        this.handContainer.visible = value ?? !this.handContainer.visible;
        this.updateMask();
        this.tableContainer.resetHeight(this.getTableHeight());
    }

    /**
     * Обновить цвет игрока
     */
    public updatePlayerColor(): string {
        const playerId = store.getters.getPlayerId as string;
        const players = store.getters.getPlayers;
        let player: Player = (players as Array<Player>)
            .find((value: Player) => value.id === playerId) as Player;
        this.isGuest = playerId ? (player?.isGuest ?? true) : false;

        if (player && player.color.code) {
            this.playerColorCode = player.color.code;
            this.playerColor = parseInt(player.color.code.slice(1), 16);
            this.dropShadowFilter = new DropShadowFilter({
                alpha: 0.9,
                // blur: 6,
                distance: 8
            });
            this.glowFilter = new GlowFilter({
                color: this.playerColor,
                distance: 16,
                outerStrength: 2,
                // innerStrength: 1,
                quality: 0.5
            });
            this.outlineFilter = new OutlineFilter(4, this.playerColor);
        }
        return player?.color?.code;
    }

    public createCard(iCard: ICard, pileZ = 0): GameObject {
        return new PixiCard(this, iCard, pileZ) as PIXI.Container;
    }

    /**
     * Добавление карте интерактвности
     */
    public addInteractivity(sprite: PIXI.Sprite | PIXI.Container): PIXI.Sprite | PIXI.Container {
        sprite.interactive = true;
        sprite.buttonMode = true;

        let onClick = (event: PIXI.InteractionEvent) => {
            if (this.isGuest) {
                return;
            }
            if ('tableContainer' === event?.target.name) {
                PixiSelector.clearAll();
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'click'});
                return;
            }

            if (this.selectedTarget) {
                // console.log('%c ### INTERACTIVE ON:', 'color: #f0f', this.selectedTarget.name);
                this.selectedTarget.interactive = true;
                this.selectedTarget.buttonMode = true;
                this.isHovering = false;
            }

            const shiftKey = event?.data.originalEvent.shiftKey;
            const rightClick = event?.data.originalEvent.which === 3;
            // console.log('%c ### Click ----->', 'color: #f0f', shiftKey, rightClick, event);

            let card = typeof event !== 'undefined' && event.target ? event.target as PixiCard : null;
            if (card) {
                if ('table' === card.zone && this.handContainer.isPointOverHand(event.data.global, false)) {
                    return;
                }

                if (!card.locked) {
                    EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'select'});
                    PixiSelector.add(card, shiftKey, rightClick);
                    card.setFilter(this.outlineFilter);
                } else {
                    EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'click'});
                    PixiSelector.clearAll();
                }
            }

        };

        let onDragStart = (event: PIXI.InteractionEvent) => {
            if (this.isGuest) {
                return;
            }
            if (event.target !== event.currentTarget) {
                return;
            }

            // const rightClick = event?.data.originalEvent.which === 3;
            this.isDragging = false;
            this.dragStart.x = event.data.global.x;
            this.dragStart.y = event.data.global.y;

            this.selectedTarget = event.target as GameObject;
            let card = event.target as PixiCard;
            if (card) {
                if ('table' === card.zone) {
                    if (this.handContainer.isPointOverHand(event.data.global, false)) {
                        return;
                    }
                }
                if (card.isStatic || card.blocked) {
                    return;
                }
                if (card.locked) {
                    this.pixiMouse.update(card.pileLength, card.locked);
                    this.selectedTarget = this.tableContainer;
                } else {
                    this.pixiMouse.update();
                }
            }
            // console.log('%c ### Drag Start: =====>', 'color: #f0f', event);
            if (card.isStatic || this.isGuest) {
                this.selectedTarget = this.tableContainer;
            }
            if (this.app && this.selectedTarget) {
                this.pieMenu?.closeMenu();
                let position: PIXI.Point = new PIXI.Point;
                this.selectedTarget.parent.toLocal(event.data.global, void 0, position);
                this.delta = {
                    x: this.selectedTarget.x - position.x,
                    y: this.selectedTarget.y - position.y
                };

                if ('tableContainer' === this.selectedTarget.name) {
                    this.selectedTarget.cursor = 'default';
                    let shiftKey = event?.data.originalEvent.shiftKey;
                    if (shiftKey) {
                        let position0: PIXI.Point = new PIXI.Point;
                        this.tableContainer.toLocal(event.data.global, void 0, position0);
                        this.tableContainer.startBox(position0);
                    }
                } else {
                    let card = this.selectedTarget as PixiCard;
                    // card.cursor = 'grabbing';
                    if ('table' === card.zone && this.handContainer.isPointOverHand(event.data.global, false)) {
                        return;
                    }
                    this.soloDrag = (card && card.isTop());
                    this.moveToTop(this.selectedTarget);
                }
                // console.log('%c ### *** MOVE ON ***', 'color: #f0f');
                this.app.stage.on('pointermove', onDragMove);
            }
        };

        let onDragEnd = (event: PIXI.InteractionEvent) => {
            if (this.isGuest) {
                return;
            }
            // console.log('%c ### Drag End: =====>', 'color: #f0f', event);
            EventApi.triggerEvent(EventApi.TABLE_DRAG_ENDED, {stage: this});
            if (this.app && this.selectedTarget) {
                if ('tableContainer' === this.selectedTarget.name) {
                    let shiftKey = event?.data.originalEvent.shiftKey;
                    if (shiftKey) {
                        this.tableContainer.selectBox();
                    }
                    this.tableContainer.unzip();
                } else {
                    let card = this.selectedTarget as PixiCard;
                    let dropOntoPile = (this.hoverTarget
                        && this.hoverTarget.name !== this.selectedTarget.name
                        && (this.hoverTarget as PixiCard).marked
                    );
                    let srcPileId = 0, dstPileId = 0;
                    if (dropOntoPile) {
                        srcPileId = (this.selectedTarget as PixiCard).pileId;
                        dstPileId = (this.hoverTarget as PixiCard).pileId;
                    }

                    const dropDist = (event) ? Math.hypot(
                        (event.data.global.x - this.dragStart.x),
                        (event.data.global.y - this.dragStart.y)
                    ) : 0;
                    const minDropDist = Math.min(card.width, card.height) * this.topContainer.scale.x / 2;
                    const mustSnapBack = dropDist < minDropDist;

                    // console.log('%c ### INTERACTIVE ON:', 'color: #f0f', this.selectedTarget.name);
                    this.selectedTarget.interactive = true;
                    this.selectedTarget.buttonMode = true;
                    this.isHovering = false;
                    this.handContainer.backgroundTint = false;

                    let modelPosition = this.getModelPosition(card);
                    if (!modelPosition.cardId) {
                        throw new Error('Card has no attributes!');
                    }

                    if ('table' === modelPosition.zone) {
                        if (this.isOverHand && !this.bottomOverHand) {
                            card.goDown(); //'hand'
                            EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'itemTakeToHand'});

                            let handIndex = 0;
                            if (this.hoverTarget && this.hoverTarget.name !== this.selectedTarget.name) {
                                handIndex = (this.hoverTarget as PixiCard).handIndex;
                            } else {
                                handIndex = this.handContainer.isPointOverLeftHalf() ? 0 : this.handContainer.handSize;
                            }

                            let flipList: Array<number> = [];
                            if (this.isDragFlip) {
                                flipList = PixiMessenger.getSelectedIds(card, true);
                            }

                            if (this.soloDrag) {
                                console.log('%c ### PILE! ---> HAND (type: 5)', 'color: #f0f');
                                MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_TO_PLAYER, {
                                    ids: [modelPosition.cardId],
                                    playerId: this.playerId,
                                    flip: flipList,
                                    handIndex: handIndex
                                });
                            } else {
                                console.log('%c ### TABLE ---> HAND (type: 3)', 'color: #f0f');
                                let list = PixiMessenger.getSelectedIds(card);
                                MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_MOVE_TO_PLAYER, {
                                    ids: list,
                                    playerId: this.playerId,
                                    flip: flipList,
                                    handIndex: handIndex
                                });
                            }
                            this.pixiMouse.update();
                        } else {
                            card.goDown();
                            if (dropOntoPile && srcPileId !== dstPileId) {
                                if (this.soloDrag) {
                                    console.log('%c ### PILE! ---> PILE! (type: 11)', 'color: #f0f', modelPosition.cardId, '->', dstPileId);
                                    MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_SOLO_CARD_TO_STACK, {
                                        ids: [modelPosition.cardId],
                                        stackId: dstPileId,
                                        flip: this.isDragFlip
                                    });
                                } else {
                                    console.log('%c ### TABLE ---> PILE! (type: 12)', 'color: #f0f', srcPileId, '->', dstPileId);
                                    let list = PixiMessenger.getSelectedIds(card);
                                    MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_MERGE_STACKS, {
                                        stacks: list,
                                        id: dstPileId,
                                        flip: this.isDragFlip
                                    });
                                }
                                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'addToPile'});
                            } else {
                                if (this.soloDrag) {
                                    if (mustSnapBack) {
                                        card.snapBack();
                                    } else {
                                        console.log('%c ### PILE! ---> TABLE (type: 6)', 'color: #f0f');
                                        card.locked = true;
                                        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_ON_TABLE, {
                                            x: modelPosition.x,
                                            y: modelPosition.y,
                                            id: modelPosition.cardId,
                                            flip: this.isDragFlip,
                                            delta: card.angleDelta
                                        });
                                    }
                                } else {
                                    console.log('%c ### TABLE ---> TABLE (type: 4)', 'color: #f0f');
                                    if (this.isDragFlip) {
                                        card.wait();
                                    }
                                    let list = PixiSelector.getSelected('table');
                                    if (this.selectedTarget && !list.includes(card)) {
                                        list.push(card);
                                    }
                                    let idList = list.map(it => {
                                        let modelPos = this.getModelPosition(it);
                                        return {id: modelPos.pileId, x: modelPos.x, y: modelPos.y};
                                    });
                                    MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_MOVE_ON_TABLE, {
                                        stacks: idList,
                                        flip: this.isDragFlip,
                                        delta: card.angleDelta
                                    });
                                }
                            }
                        }
                    } else if ('hand' === modelPosition.zone) {
                        let destId = -1, overLeftHalf = false;
                        if (!event) {
                            overLeftHalf = this.handContainer.isPointOverLeftHalf();
                            const cardsList = this.handContainer.getCardIds();
                            destId = overLeftHalf ? cardsList[0] : -1;
                        }
                        if (this.isOverHand || this.mouseOut) {
                            card.goDown();
                            const target = this.hoverTarget as PixiCard;
                            destId = target?.cardId ?? destId;
                            const handIds = PixiSelector.getHandIds();
                            if (!handIds.includes(card.cardId)) {
                                handIds.push(card.cardId);
                            }
                            console.log('%c ### HAND ---> HAND', 'color: #f0f', destId, handIds);
                            this.handContainer.relocate(handIds, destId);

                            let flipList: Array<number> = this.isDragFlip ? handIds : [];
                            PixiMessenger.changeHandItemsSort(flipList);
                            this.handContainer.updateHand();
                        } else {
                            if (dropOntoPile && srcPileId !== dstPileId) {
                                console.log('%c ### HAND ---> PILE! (type: 11)', 'color: #f0f');
                                card.goDown('table');
                                let list = PixiMessenger.getSelectedIds(card);
                                MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_SOLO_CARD_TO_STACK, {
                                    ids: list,
                                    stackId: dstPileId,
                                    flip: this.isDragFlip
                                });
                            } else {
                                console.log('%c ### HAND ---> TABLE (type: 4)', 'color: #f0f');
                                const cardList = PixiSelector.all();
                                this.clonedCards = cardList.map(it => it.createClone());
                                cardList.forEach(it => it.visible = false);
                                card.goDown('table');

                                let position: PIXI.Point = new PIXI.Point;
                                if (event && event.data) {
                                    this.tableContainer.toLocal(event.data.global, void 0, position);
                                }

                                position.x += this.delta.x - this.handShift;
                                position.y += this.delta.y;

                                let list = PixiMessenger.getSelectedIds(card);
                                MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_TO_TABLE_FROM_HAND, {
                                    ids: list,
                                    x: position.x - card.size.width / 2,
                                    y: position.y - card.size.height / 2,
                                    flip: this.isDragFlip,
                                    delta: card.angleDelta
                                });
                            }
                        }
                    } else {
                        console.warn('Unknown zone:', modelPosition.zone);
                    }
                    PixiSelector.clearAll();
                }
                this.isDragFlip = false;
                this.mouseOut = false;

            }
        };

        let onDragMove = (event: PIXI.InteractionEvent) => {
            // console.log('%c ### Drag Move: =====>', 'color: #f0f', event);
            if (this.isMafia) {
                return;
            }
            if (!this.isDragging) {
                const dX = Math.abs(event.data.global.x - this.dragStart.x);
                const dY = Math.abs(event.data.global.y - this.dragStart.y);
                const tolerance = 8;
                if (dX < tolerance && dY < tolerance) {
                    return;
                }
            }

            let shiftKey = event?.data.originalEvent.shiftKey;
            if (this.app && this.selectedTarget && this.selectedTarget.parent) {
                let card = this.selectedTarget as PixiCard;
                if (!this.isDragging) {
                    if (this.soloDrag) {
                        if (PixiSelector.all().length) {
                            PixiSelector.clearAll();
                        }
                    } else if ('tableContainer' !== this.selectedTarget.name && !card.isStatic && !card.selected) {
                        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'select'});
                        PixiSelector.add(card, shiftKey, false, false, true);
                        card.setFilter(this.outlineFilter);
                    }
                    EventApi.triggerEvent(EventApi.TABLE_DRAG_STARTED, {stage: this});
                }

                this.isDragging = true;
                let position: PIXI.Point = new PIXI.Point;
                this.selectedTarget.parent.toLocal(event.data.global, void 0, position);

                if ('tableContainer' === this.selectedTarget.name) {
                    if (this.handContainer.isPointOverHand(event.data.global, false)) {
                        return;
                    }
                    if (shiftKey) {
                        let positionEnd: PIXI.Point = new PIXI.Point;
                        this.tableContainer.toLocal(event.data.global, void 0, positionEnd);
                        this.tableContainer.drawBox(positionEnd);
                        return;
                    }
                    this.tableContainer.move(position.x + this.delta.x, position.y + this.delta.y);
                } else {
                    this.isOverHand = this.handContainer.isPointOverHand(event.data.global, true);
                    card.interactive = false;
                    card.buttonMode = false;
                    const isMoveValid = card.move(position.x + this.delta.x, position.y + this.delta.y, true);
                    if (this.isTransformed) {
                        this.isTransformed = false;
                        if (!isMoveValid) {
                            this.mouseOut = true;
                            this.selectedTarget.emit('pointerup');
                            return;
                        }
                    }

                    const gap = 10, borderWidth = 6;
                    let scale = ('hand' === card.zone) ? (card.handScale * this.handContainer.hoverScale) : this.topContainer.scale.x;
                    let bottomPos: PIXI.Point = new PIXI.Point;
                    this.selectedTarget?.parent?.toGlobal(card.position, bottomPos);
                    bottomPos.y += scale * card.size.height / 2 + gap + borderWidth;
                    let bottomOverHand = this.handContainer.isPointOverHand(bottomPos, false);

                    if (card && !this.isHovering) {
                        this.bottomOverHand = bottomOverHand;
                        if (!bottomOverHand) {
                            card.goUp(true);
                        }
                    }
                    this.isHovering = true;

                    if (this.bottomOverHand && !bottomOverHand) {
                        this.bottomOverHand = bottomOverHand;
                        if (PixiType.ZONE_HAND === card.zone) {
                            const hoverScale = card.handScale * this.handContainer.hoverScale;
                            this.delta = {
                                x: this.delta.x / hoverScale,
                                y: this.delta.y / hoverScale
                            };

                            const list = PixiSelector.getSelected(card.zone);
                            if (!list.includes(card)) {
                                list.push(card);
                            }
                            list.sort((a, b) => a.handIndex - b.handIndex);
                            const cardIndex = list.findIndex(it => it === card);
                            const cardGap = 20;
                            // const handList = list.map(it => it.handIndex);
                            // console.log('%c ### handList', 'color: #f0f', cardIndex, handList);

                            list.forEach((it, i) => {
                                it.scale.set(1);
                                it.x = card.x + (card.size.width + cardGap) * (i - cardIndex);
                                it.y = card.y;
                            });
                            this.handShift = list[cardIndex].x - list[0].x;
                            this.isTransformed = true;
                        }
                        card.goUp(true);
                    }
                    // console.log('%c ### INTERACTIVE OFF:', 'color: #f0f', this.selectedTarget.name);
                }
            }
        };

        let onPointerUp = (event: PIXI.InteractionEvent) => {
            this.app && this.app.stage.off('pointermove', onDragMove);
            this.tableContainer.clearBox();

            if (event && event.target !== event.currentTarget || this.isMafia) {
                return;
            }
            // const shiftKey = event?.data.originalEvent.shiftKey;
            // console.log('%c ### Pointer Up --->', 'color: #f0f', this.isDragging);
            let card = (event && event.target) ? (event.target as PixiCard) : null;
            if (card && card.blocked) {
                return;
            }

            if (this.isDragging) {
                onDragEnd(event);
            } else {
                if (card && card.zone === 'hand' && !this.selectedTarget) {
                    return;
                }
                onClick(event);
            }
            setTimeout(() => {
                this.isDragging = false;
            }, 0);
            this.soloDrag = false;
            this.selectedTarget = void 0;

            if (card) {
                card.cursor = 'pointer';
                this.pixiMouse.update(card.pileLength);
                if (card.clearTimer) {
                    card.clearTimer();
                }
            }
        };

        let onRightUp = (event: PIXI.InteractionEvent) => {
            if (this.isGuest || this.isMafia) {
                return;
            }
            event.data.originalEvent.preventDefault();
            event.data.originalEvent.stopPropagation();
            if (event.target !== event.currentTarget) {
                return;
            }
            let card = event.target as PixiCard;
            if (!this.app || !this.rect || !card || !card.zone || card.blocked) {
                return;
            }

            console.log('%c ### Right Up:', 'color: #f0f', 'P:', card.pileId, 'C:', card.cardId);
            if ('hand' === card.zone) {
                this.handContainer.onHover(card, true);
            }
            if (card.parentPile?.inUsage() || (!this.isInAdminMode && card.isStatic)) {
                return;
            }

            if (!this.isBanned('canViewTableMenu')) {
                this.pieMenu.moveTo(this.pixiMouse.x, this.pixiMouse.y);
                this.pieMenu.openMenu(card);
            }
        };

        let onHoverOver = (e: PIXI.InteractionEvent) => {
            if (e.target !== e.currentTarget
                || 'tableContainer' === e.target.name
                || this.isMafia || this.isGuest
            ) {
                return;
            }
            this.hoverTarget = sprite;
            let card = sprite as PixiCard;
            card.showSimiloButtonFace(true);
            if (card && card.parentPile && card.parentPile.inUsage()) {
                return;
            }
            if (this.handContainer.isPointOverHand(e.data.global, false)) {
                if ('table' === card.zone) {
                    return;
                }
            }
            if (card && card.parentPile) {
                this.pixiMouse.update(card.parentPile.getPileLength());
            }
            this.hoverOver();
        };

        sprite
            .on('pointerout',
                ('tableContainer' === sprite.name) ? () => {
                    } :
                    () => {
                        this.hoverTarget = undefined;
                        this.pixiMouse.update();
                        let card = sprite as PixiCard;
                        card.showSimiloButtonFace(false);
                        if (card && card.parentPile && card.parentPile.inUsage()) {
                            return;
                        }
                        // let selected = card.selected;
                        if (card) {
                            card.clearTimer();
                            card.setBrightness(0);
                            if (this.isHovering && card.isHovering) {
                                card.setFilterWithShadow(this.outlineFilter, this.dropShadowFilter);
                            } else {
                                card.setFilter(this.outlineFilter);
                            }
                            if (!card.locked && !this.soloDrag) {
                                if ('table' === card.zone && !this.isHovering) {
                                    card.scale.set(1);
                                }
                                if ('hand' === card.zone && !this.isHovering) {
                                    this.handContainer.onHover();
                                }
                            }
                        }
                    }
            ) // onHoverOut
            .on('pointerover', onHoverOver)
            .on('rightup', onRightUp)
            .on('pointerdown', onDragStart)
            .on('pointerup', onPointerUp)
            .on('pointerupoutside', onPointerUp);
        return sprite;
    }

    /**
     * Обработка события ховера
     */
    public hoverOver(): void {
        if (this.isGuest) {
            return;
        }
        let card = this.hoverTarget as PixiCard;
        if (card && !card.locked && !card.isStatic) {
            // if ('table' === card.zone && !this.isHovering) {
            //     card.setBrightness();
            // }

            if ('hand' === card.zone) {
                if (this.isHovering) {
                    card.setBrightness();
                } else {
                    this.handContainer.onHover(card);
                }
            }

            const theSameSize = card.theSameSizeAs(this.selectedTarget as PixiCard);
            const inSelector = PixiSelector.getTableIds().includes(card.pileId);
            if (theSameSize && !this.isOverHand && this.selectedTarget && !inSelector
                && card.name !== this.selectedTarget.name) {
                card.setTimer();
            }
        }
    }

    /**
     * Зум стола
     */
    public tableChangeZoom(mode: string): void {
        this.tableContainer.tableChangeZoom(mode);
    }

    /**
     * Закончить обновление карт на столе
     */
    public finishGameField(): void {
        if (this.app && this.rect) {
            PixiScene.firstTime = false;

            const getListDiff = (listA: Array<any>, listB: Array<any>): Array<any> => {
                let a = listA.map(it => it.id);
                let b = listB.map(it => it.id);
                return a.filter(it => !b.includes(it));
            };

            const newGameField = store.getters.getGameField;
            let tableIsDirty = this.tableContainer.isDirty(this.gameField, newGameField);
            if (tableIsDirty) {
                this.tableContainer.addBackground(newGameField);
            }

            const oldTableList = this.getTableCards(this.gameField).filter((it: any) => !it.masterLocked);
            const newTableList = this.getTableCards(newGameField).filter((it: any) => !it.masterLocked);
            if (this.isInAdminMode) {
                if (JSON.stringify(oldTableList) !== JSON.stringify(newTableList)) {
                    newTableList.forEach((pileConfig) => {
                        const visibilityObj: {[key: number]: boolean} = {};
                        pileConfig.cards.forEach((cardConf: any) => {
                            visibilityObj[cardConf.id] = cardConf.onTable;
                        });
                        if (typeof this.pileMap.get(pileConfig.id) !== 'undefined') {
                            const pile: PixiPile = this.pileMap.get(pileConfig.id).parentPile;
                            pile.toggleCardVisibilityInAdminMode(visibilityObj);
                        }
                    });
                }
            }

            const oldHandList = this.getHandCards(this.gameField);
            const newHandList = this.getHandCards(newGameField);
            //--------------------------------------------------------------------HAND::ADD
            const addList = getListDiff(newHandList, oldHandList);
            addList.forEach(id => {
                let conf = newHandList.find(it => it.id == id);
                if (conf) {
                    this.createHandCard(conf);
                } else {
                    console.warn('Unknown Card ID: ' + id);
                }
            });

            this.handContainer.setOrder(newHandList.map(it => it.id));
            this.handContainer.updateHand();
            this.gameField = newGameField;
        }
    }

    /**
     * Поднимаем объект в списке потомков
     */
    public moveToTop(item: PIXI.Sprite | PIXI.Container): PIXI.Sprite | PIXI.Container {
        let parent = item?.parent;
        if (item && parent) {
            parent.removeChild(item as any);
            parent.addChild(item);
        }
        return item;
    }

    /**
     * Установка атрибута
     */
    public setAttr(card: any, value: any): void {
        if (!card.attrs) {
            card.attrs = {};
        }
        card.attrs = {...card.attrs, ...value};
    }

    /**
     * Для увеличения по пробелу
     */
    public getHoverSrc(): Array<string> | undefined {
        if (this.isBanned('canTablePreviewCards')) {
            return [];
        }
        const card = (this.selectedTarget || this.hoverTarget) as PixiCard;
        this.cardHandIndex = card ? card.handIndex : -1;
        setTimeout(() => this.handContainer.updateSlider(this.cardHandIndex), 50);

        if (typeof card === 'undefined') {
            return [];
        }
        if (card.isStatic) {
            return [];
        }
        card.selected = false;

        EventApi.triggerEvent(EventApi.EDIT_START, {
            cardId: card.cardId,
            pileId: card.pileId,
            actions: card.paintActions,
            bgSrc: card.bgSrc,
            playerColorCode: this.playerColorCode,
            cardSize: card.size
        });

        const settings = this.gameState?.tasks?.state?.activity?.settings;
        const CAN_DRAW = 'canTableDrawOnCards';
        const canDraw = !(settings && false === settings[CAN_DRAW]);

        if (canDraw && card && 'table' === card.zone && !card.isStatic) {
            PixiMessenger.sendDisableCardMessage([card.pileId], true);
        }
        return card ? [card.cardSrc] : [];
        // return card ? [card.config.face_src] : []; // ...for Painter
    }

    /**
     * Удаление пачки по ID
     */
    public deletePileById(id: number): void {
        if (this.pileMap.has(id)) {
            let pileCard = this.pileMap.get(id) as PixiCard;
            let pile = pileCard.parentPile;
            pile?.dropRest();
            this.tableContainer.removeCard(pileCard);
            this.pileMap.delete(id);
        }
    }

    /**
     * Пересоздание пачки по ID
     */
    public recreatePileById(id: number): PixiCard | undefined {
        let flipTopCard;
        const pileConf = this.modelState.getPile(id);
        if (id && pileConf && pileConf.cards?.length > 1) {
            this.deletePileById(id);
            const pile = this.createPile(pileConf) as PixiPile;
            flipTopCard = pile?.flipTopCard;
            if (flipTopCard) {
                this.tableContainer.addCard(flipTopCard);
            }
        }
        return flipTopCard;
    }

    /**
     * Блокировка
     */
    public setLocked(value: boolean): void {
        this.isLocked = value;
    }

    /**
     * Центр сцены на столе
     */
    public getSceneCenter(): PIXI.Point {
        let position: PIXI.Point = new PIXI.Point;
        if (this.rect) {
            const height = this.handContainer.visible ? (this.rect.height - this.handContainer.getHandHeight()) : this.rect.height;
            this.tableContainer.toLocal({
                x: this.rect.width / 2,
                y: height / 2
            }, void 0, position);
        }
        return position;
    }

    /**
     * Вращение карты
     */
    public rotateCard(card: PixiCard, delta: number) {
        if (card && !card.locked && !card.isStatic) {
            if (card.zone === 'table' || this.isDragging) {
                const rotateStep = 15;
                const list = PixiSelector.getSelected(card.zone);
                list.forEach(it => (it as PixiCard).rotateDelta(delta * rotateStep, this.soloDrag));
                EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'click'});
                if (!this.isDragging) {
                    PixiMessenger.rotateStackDelta(delta * rotateStep, card);
                }
            }
        }
    }

    /**
     * Клавиатура
     */
    public onPixiKeyup(e: KeyboardEvent): void {
        if (this.isGuest || store.getters.getPainterEditMode) {
            return;
        }
        if (this.painter && this.painter.visible) {
            this.painter.onKeyup(e);
            return;
        }
        if (this.isBanned('canViewShortcuts')) {
            return;
        }
        let keyTarget = (this.hoverTarget as PixiCard) || PixiSelector.firstCard;
        let hasTarget = keyTarget && !this.isDragging;
        let zone = keyTarget?.zone ?? '';

        switch (e.code) {
            case 'ArrowDown':
                this.handleArrows(2);
                break;
            case 'ArrowLeft':
                this.handleArrows(-1);
                break;
            case 'ArrowRight':
                this.handleArrows(1);
                break;
            case 'ArrowUp':
                this.handleArrows(-2);
                break;
            case 'Delete':
                if (hasTarget) {
                    PixiMessenger.deleteCards(keyTarget, this.isAdmin);
                }
                break;
            case 'KeyF':
                let target = (this.selectedTarget as PixiCard) || keyTarget;
                if (target && target.tweener.flipping) {
                    break;
                }
                if (target && !target.waiting) {
                    if (this.isDragging) {
                        if (PixiType.ZONE_HAND === target.zone) {
                            const handIds = PixiSelector.getHandIds();
                            if (!handIds.includes(target.cardId)) {
                                handIds.push(target.cardId);
                            }
                            const flipOK = this.flipCards(handIds);
                            if (flipOK) {
                                this.isDragFlip = !this.isDragFlip;
                                this.modelState.setDragFlip();
                            }
                        } else if (PixiType.ZONE_TABLE === PixiSelector.zone) {
                            const flipOK = this.flipPilesOld(PixiSelector.getTableIds());
                            if (flipOK) {
                                this.isDragFlip = !this.isDragFlip;
                                this.modelState.setDragFlip();
                            }
                        } else if (this.soloDrag) {
                            const targetId = (this.selectedTarget as PixiCard)?.pileId;
                            if (targetId) {
                                const flipOK = this.flipPilesOld([targetId]);
                                if (flipOK) {
                                    this.isDragFlip = !this.isDragFlip;
                                    this.modelState.setDragFlip();
                                }
                            }
                        }
                    } else {
                        const debounce = (func: () => void, delay: number) => {
                            let inDebounce: number;
                            return function () {
                                window.clearTimeout(inDebounce);
                                inDebounce = window.setTimeout(func, delay);
                            };
                        };
                        debounce(() => {
                            PixiMessenger.sendFlip(target as PixiCard);
                        }, 300)();
                    }
                }
                break;
            case 'KeyL':
                if (hasTarget) {
                    PixiMessenger.lockTableItems(keyTarget);
                }
                break;
            case 'KeyS':
                if (hasTarget) {
                    PixiMessenger.shuffleSelectedTableItems(keyTarget);
                }
                break;
            case 'KeyH':
                if (hasTarget && zone === 'table') {
                    PixiMessenger.moveToHandOrTable(keyTarget);
                }
                break;
            case 'KeyT':
                if (hasTarget && zone === 'hand') {
                    this.hoverTargetT = this.hoverTarget;
                    PixiMessenger.moveToHandOrTable(keyTarget);
                }
                break;
            case 'BracketRight':
                if (e.shiftKey) {
                    // this.debugBox.visible = !this.debugBox.visible;
                    // if (this.painter) {
                    //     this.painter.visible = true;
                    // }
                }
                break;
            case 'Escape':
                this.debugBox.visible = false;
                this.pieMenu?.closeMenu();
                PixiSelector.clearAll();
                break;
            case 'NumpadAdd':
                this.tableContainer.tableChangeZoom('+');
                break;
            case 'NumpadSubtract':
                this.tableContainer.tableChangeZoom('-');
                break;
            case 'NumpadMultiply':
                this.tableContainer.resetZoom();
                break;
            case 'NumpadDivide':
                this.tableContainer.minZoom();
                break;
            case 'KeyQ':
                this.rotateCard((this.selectedTarget as PixiCard) || keyTarget, -1);
                break;
            case 'KeyE':
                this.rotateCard((this.selectedTarget as PixiCard) || keyTarget, 1);
                break;
            case 'KeyI':
                // PixiMessenger.sendDisableCardMessage([keyTarget.pileId], true);
                // this.tableContainer.showSimiloButtons();
                break;
            case 'AltLeft':
            case 'ControlLeft':
            case 'ShiftLeft':
            case 'Space':
                break;
            default:
                console.log('%c ### Key Up:', 'color: #f0f', e.code, e);
        }
    }

    /**
     * Выделенные карты / пачки
     */
    public getSelectedIds(zone: string): Array<number> {
        return PixiSelector.getSelectedIds(zone);
    }

    /**
     * Закрытие контекстного меню
     */
    public onCloseContextMenu(): void {
        this.handContainer.onHover();
    }

    /**
     * Отладка
     */
    public info(value: any): void {
        console.log('%c ### PixiScene::info', 'color: #f0f', value);
    }

    /**
     * Определить, произошел дроп в зону руки или стола
     * @param y
     */
    public getDropZone(y: number): string {
        const handIsOpened = this.handContainer.visible;

        if (!handIsOpened) {
            return 'table';
        }

        if (!this.rect) {
            return '';
        }

        const tableBottom = this.rect?.y + this.rect?.height - this.handContainer.getHandHeight();

        if (y > tableBottom) {
            return 'hand';
        }

        return 'table';
    }

    /**
     * Получить выбранную карту:
     */
    public getSelectedCard(): PixiCard | undefined {
        return (!this.selectedTarget || 'tableContainer' === this.selectedTarget.name) ?
            undefined : this.selectedTarget as PixiCard;
    }

    /**
     * HUD для отладки:
     */
    public addDebugHUD(): void {
        let width = this.rect!.width, height = this.rect!.height;
        height -= this.handContainer.getHandHeight(true);
        const hud = new PIXI.Graphics();
        hud.lineStyle(1, 0xff00ff, 0.75);
        hud.drawRect(width / 2 - 100, height / 2 - 100, 200, 200);
        hud.drawRect(16, 16, width - 32, height - 32);
        hud.moveTo(0, height / 2);
        hud.lineTo(width, height / 2);
        hud.moveTo(width / 2, 0);
        hud.lineTo(width / 2, height);
        this.app!.stage.addChild(hud);
    }

    /**
     * для отладки:
     */
    public addLayer(layer: PIXI.Graphics): void {
        this.app!.stage.addChild(layer);
    }

    public getTableCameraParams(): any {
        return {
            x: this.tableContainer.x,
            y: this.tableContainer.y,
            scale: this.tableContainer.scale.x,
            width: this.tableContainer.stage.width,
            height: this.tableContainer.stage.height
        };
    }

    /**
     * Установить статус гостя
     * @param value
     */
    public setGuestStatus(value: boolean): void {
        this.isGuest = value;
        if (this.isGuest) {
            PixiSelector.clearAll();
        }
    }

    /**
     * Игра перезагружается
     */
    public restartGame(): void {
        this.isRestarting = true;
    }

    /**
     * Обработка диффов
     */
    public diffHandler(data: Array<any>): void {
        if (typeof data === 'undefined' || !data) {
            return;
        }
        // console.log('%c ### DIFF::', 'color: #f0f', data.length);
        let mustUpdateHand: boolean = false;
        let flipIds: Array<number> = [];
        data.forEach((it: any, index) => {
            // console.log('%c ### ->', 'color: #f0f', index, it.operation, it.value?.stack?.id);
            switch (it.operation) {
                case 'addStack':
                    // console.log('%c ### ADD:', 'color: #f0f', it.value.stack.id);
                    this.modelState.diffHandler(it);
                    this.signalCardAdditionByPlayer(it.value.stack.id, it.value.playerId);
                    break;
                case 'clearField':
                    this.clearField = true;
                    this.mustUpdate = true;
                    // this.logoPos = null;
                    break;
                case 'changePlayerCardsCount':
                    // console.log('%c ### diff::changePlayerCardsCount:', 'color: #f0f', it.value);
                    break;
                case 'deleteCards':
                    // console.log('%c ### diff::deleteCard:', 'color: #f0f', it.value);
                    this.modelState.diffHandler(it);

                    (it.value.ids as Array<number>).forEach(id => {
                        this.handContainer.removeById(id);
                    });
                    mustUpdateHand = true;
                    break;
                case 'flipCard':
                    // console.log('%c ### diff::flipCard:', 'color: #f0f', it.value);
                    flipIds.push(it.value.id);
                    break;
                case 'updatePaint':
                    // console.log('%c ### diff::updatePaint:', 'color: #f0f', it.value);
                    EventApi.triggerEvent(EventApi.EDIT_DONE, it.value);
                    // this.modelState.diffHandler(it);
                    break;
                default:
                    /* By default, just goes to modelState */
                    this.modelState.diffHandler(it);
            }
        });

        if (mustUpdateHand) {
            this.handContainer.updateHand();
            this.handContainer.onHover();
            mustUpdateHand = false;
        }
        if (flipIds.length) {
            this.flipCards(flipIds);
            flipIds = [];
        }

    }

    /**
     * Обработка сообщений (GameRoom / EditField)
     */
    public messageHandler(type: string, ids: Array<number>): void {
        switch (type) {
            default:
                console.warn('unknown message type: ' + type);
        }
    }

    /**
     * Обработка ошибок (GameRoom / EditField)
     */
    public errorHandler(type: string): void {
        const TYPE_ACTIVITY_PROCESS_ERROR = 'activityProcessError';
        switch (type) {
            case TYPE_ACTIVITY_PROCESS_ERROR:
                this.wrongMove();
                break;
            default:
                console.warn('unknown error type: ' + type);
        }
    }

    /**
     * Обработка игрового поля
     */
    public gameFieldHandler(gameField: any, init = false): void {
        this.similoCards = [];
        this.similoSelected = 0;
        this.getTableCards(gameField).forEach((it, i) => {
            const card = it?.cards?.[0];
            if (card && 'play' === card.metaType) {
                this.similoCards.push(+card.id);
                if (card.selected) {
                    this.similoSelected = +card.id;
                }
            }
        });
        // console.log('%c ### $$$ isMetaType::tableCards:', 'color: #f0f', this.similoCards);
        this.tableContainer.showSimiloButtons(this.isSimilo);

        this.modelState.update(gameField);

        if (this.mustResize) {
            this.mustResize = false;
            this.resizeHandler(false);
            return;
        }

        if (this.isDragging) {
            return;
        }
        if (this.isAdmin) {
            this.tableContainer.toggleLogo(gameField.showLogo !== false);
            if (this.gameField.background.pattern !== gameField.background.pattern) {
                this.mustUpdate = true;
                PixiUtil.delay(100).then(() => {
                    this.toggleHand(false);
                });
            }
        }
        if (!init) {
            this.refreshGameField();
        }
        this.diffUpdate();
    }

    /**
     * Низ Карты под Рукой
     */
    public isCardBottomUnderHand(): boolean {
        if (!this.handContainer.visible) {
            return false;
        }
        const card = this.selectedTarget as PixiCard;
        let bottomPos = card?.parent?.toGlobal(card.position);
        const scale = ('hand' === card.zone) ? (card.handScale * this.handContainer.hoverScale) : this.topContainer.scale.x;
        const gap = 10, borderWidth = 6;
        bottomPos.y += scale * card.size.height / 2 + gap + borderWidth;
        const handBottom = this.handContainer.y + this.handContainer.getHandHeight();
        return bottomPos.y > handBottom;
    }

    public getLogoPos() {
        return this.logoPos;
    }

    public setLogoPos(x: number, y: number) {
        this.logoPos = {x: x, y: y};
    }

    /**
     * Проверка запретов в настройках
     */
    public isBanned(actionId: string): boolean {
        const settings = this.gameState?.tasks?.state?.activity?.settings;
        return !!(settings && false === settings[actionId]);
    }

    /**
     * Не отрисовывать элемент за столом
     */
    public hideOffScreenItem(cont: PIXI.DisplayObject): void {
        const bounds = cont.getBounds();
        const isOff = bounds.right < this.pixiRect.left || bounds.bottom < this.pixiRect.top
            || this.pixiRect.right < bounds.left || this.pixiRect.bottom < bounds.top;
        cont.visible = !isOff;
    }

    /**
     * Обработка игрового состояния
     */
    public gameStateHandler(gameState: any): void {
        this.isSimiloGM = 1 === gameState?.automation?.playersMap?.[this.playerId]?.role?.value;
        this.buttonsSimilo = gameState?.zones?.chat?.buttons?.similo?.delete?.enabled ?? false;
        this.tableContainer.showSimiloButtons(this.isSimilo);

        this.updatePlayerColor();
        this.layoutType = gameState?.tasks?.state?.activity?.settings?.layoutType;

        this.gameState = gameState;
    }

    /**
     * Проверка метатипа карты
     */
    public isSimiloCard(value: number): boolean {
        return this.similoCards.includes(value);
    }

    /**
     * Симило-карта выделена (оранжевая рамка)?
     */
    public isSimiloCardSelected(value: number): boolean {
        return this.similoSelected === value;
    }

    public destroyApp(): void {
        this.app?.destroy(true, {
            children: true,
            texture: true,
            baseTexture: true
        });
    }

    /**
     * Инициализация
     */
    private initAll(handContainerVisible: boolean, tableBorderTint: number): void {
        if (!this.app || !this.rect) {
            return;
        }
        this.playerId = store.getters.getPlayerId as string;
        this.players = store.getters.getPlayers as Array<Player>;
        this.modelState.setPlayers(this.playerId, this.players);
        this.gameField = store.getters.getGameField;
        this.gameFieldHandler(this.gameField, true);
        const firstInit = !this.gameState;
        this.gameState = store.getters.getGameState;
        const activity = this.gameState?.tasks?.state?.activity;
        // if (activity) {
        //     console.log('%c ### Activity:', 'color: #f0f', activity.id, activity.name, activity.settings);
        // }

        // this.buttonsSimilo = this.gameState?.zones?.chat?.buttons?.similo?.delete?.enabled ?? false;
        // this.buttonsSimilo = true; //TEST

        let scale = this.gameField.stage.scale.x;
        this.app.stage.addChild(this.mat);
        this.tableContainer = new PixiTable(this, {});
        this.app.stage.addChild(this.tableContainer);
        // this.addDebugHUD();

        this.handContainer = new PixiHand(this, this.translations);
        this.handContainer.visible = handContainerVisible;
        this.addGap(tableBorderTint);
        this.app.stage.addChild(this.handContainer);
        this.pixiRect.height = this.getTableHeight();

        this.topContainer.removeChildren();
        this.topContainer = new PIXI.Container();
        this.app.stage.addChild(this.topContainer);
        this.topContainer.name = 'topContainer';
        this.topContainer.scale.set(scale);
        this.topContainer.x = this.gameField.stage.x;
        this.topContainer.y = this.gameField.stage.y;

        this.pixiMouse = new PixiMouse(this);
        this.app.stage.addChild(this.pixiMouse);
        this.pixiMouse.update();

        this.pieMenu = new PixiPieMenu(this);
        this.app.stage.addChild(this.pieMenu);
        this.pieMenu.visible = false;

        // this.painter = new Painter(this.app.renderer, 512, 512);
        // this.painter.addTo(this.app.stage, this.rect.width, this.rect.height - this.handContainer.getHandHeight());
        // this.painter.visible = false;

        this.app.stage.addChild(this.debugBox);
        this.layoutType = this.gameState && this.gameState.tasks.state.activity
            ? this.gameState.tasks.state.activity.settings.layoutType
            : 1;

        if (this.layoutType === 5) {
            this.videoContainer = new PixiVideoContainer();
            this.app.stage.addChild(this.videoContainer);
        }

        this.initTable();
        this.initHand();

        if (firstInit) {
            MessageHelper.getState();
        }

        if (!this.isTicking) {
            this.app?.ticker.add((delta) => {
                if (this.painter && this.painter.visible) {
                    this.painter.update(delta);
                }
                this.tableContainer.commitMove();
                if (!this.isDragging) {
                    this.diffUpdate();
                }
                TWEEN.update();
                this.tableContainer.hideOffScreenItems();
            });
            this.isTicking = true;
        }

    }

    /**
     * Промежуток между Рукой и Столом
     * @private
     */
    private addGap(tableBorderTint: number): void {
        if (!this.app || !this.rect) {
            return;
        }
        this.mat.width = this.rect.width;
        this.mat.height = this.rect.height;
        this.mat.cursor = 'default';
        this.mat.alpha = 0;
        this.mat.interactive = true;
        this.mat.on('pointerup', (e) => {
            if (!this.isOverHand && this.selectedTarget && this.selectedTarget.name !== 'tableContainer') {
                this.mouseOut = true;
            }
            this.selectedTarget?.emit('pointerup');
        });

        this.app.stage.addChild(this.tableMask);
        this.app.stage.addChild(this.handMask);
        this.tableMask.lineStyle(0);
        this.handMask.lineStyle(0);
        this.tableContainer.mask = this.tableMask;
        this.handContainer.bgLayer.mask = this.handMask;
        this.tableBorderColor(0xffffff === tableBorderTint ? '#F65A00' : tableBorderTint);
        this.app.stage.addChild(this.tableBorder);
        this.updateMask();
        this.tableContainer.resetHeight(this.getTableHeight());
    }

    /**
     * Высота стола с учётом руки
     */
    private getTableHeight(): number {
        if (!this.app || !this.rect) {
            return 0;
        }
        const gap = 10, borderWidth = 6, halfWidth = borderWidth / 2;
        let tableHeight = this.rect.height - 2 * halfWidth;
        if (this.handContainer.visible) {
            tableHeight = this.handContainer.y - gap - 2 * halfWidth;
        }
        return tableHeight;
    }

    /**
     * Обновить маску
     */
    private updateMask(): void {
        if (!this.app || !this.rect) {
            return;
        }
        const rad = 20, borderWidth = 6;
        this.tableMask.clear();
        this.tableBorder.clear();
        this.tableMask.beginFill(0xffffff);
        this.tableBorder.lineStyle(borderWidth, 0xffffff);

        const halfWidth = borderWidth / 2;
        if (this.handContainer.visible) {
            this.handMask.clear();
            this.handMask.beginFill(0xffffff);
            this.handMask.drawRoundedRect(0, this.handContainer.y, this.rect.width, this.handContainer.getHandHeight(), rad);
            this.handMask.endFill();
        }
        const tableHeight = this.getTableHeight();
        this.tableMask.drawRoundedRect(0, 0, this.rect.width, tableHeight, rad + halfWidth);
        this.tableMask.endFill();
        this.tableBorder.drawRoundedRect(halfWidth, halfWidth, this.rect.width - borderWidth, tableHeight, rad);
    }

    /**
     * Получение карт стола
     */
    private getTableCards(gameField: FieldState): Array<StackSetup> {
        return Array.from(gameField?.card_stacks ?? 0);
    }

    /**
     * Начальная отрисовка карт на столе
     */
    private initTable(): void {
        // console.log('%c ### INIT TABLE!', 'color: #f0f');
        this.tableContainer.addBackground();

        const addPile = (pileConf: any, i: number) => {
            // console.log('%c ### ---', 'color: #f0f', i, pileConf.id, pileConf.masterLocked);
            if (pileConf.cards.length > 0) {
                this.deletePileById(pileConf.id);
                const pile = this.createPile(pileConf) as PixiPile;
            }
        };
        // this.getTableCards(this.gameField).forEach((it:any, i:number) => addPile(it, i));

        const tableCards = this.getTableCards(this.gameField);
        tableCards.filter((it: StackSetup) => it.masterLocked).forEach((it: StackSetup, i: number) => addPile(it, i));
        tableCards.filter((it: StackSetup) => !it.masterLocked).forEach((it: StackSetup, i: number) => addPile(it, i));

    }

    /**
     * Получение карт руки
     */
    private getHandCards(gameField: FieldState): Array<any> {
        if (!this.playerId) {
            return [];
        }
        const player = gameField.players[this.playerId];
        return (player && player.cards) ? Array.from(player.cards) : [];
    }

    /**
     * Создать карту в руке
     */
    private createHandCard(conf: ICard, index: number = -1): void {
        let card = this.createCard(conf as ICard);
        if (card) {
            this.handContainer.addToHand(card, index);
            this.addInteractivity(card);
            this.setAttr(card, {
                cardId: conf.id,
                pileId: 0,
                x: 0,
                y: 0,
                width: conf.width,
                height: conf.height,
                zone: 'hand',
                handX: card.x,
                handY: card.y,
                size: 1
            });
        }
    }

    /**
     * Начальная отрисовка карт в руке
     */
    private initHand(): void {
        this.handContainer.clearAll();
        const hand = this.getHandCards(this.gameField);
        hand.forEach((conf: any, i: number) => {
            this.createHandCard(conf);
        });
        this.handContainer.updateHand();
    }

    /**
     * Добавление вида в тело документа (только для тестирования)
     */
    private testAdd(): void {
        if (this.app && this.rect) {
            document.body.appendChild(this.app?.view);
            let style = this.app?.renderer.view.style;
            style.position = 'absolute';
            style.left = this.rect.left + 'px';
            // style.left = (this.rect.left - 100) + 'px';
            // style.left = (this.rect.left + 64 + this.rect.width) + 'px';
            style.top = this.rect.top + 'px';
        }
    }

    /**
     * Переместить пачки на столе
     */
    private movePiles(diffData: Array<CardPositionDiff>, isPutOnTable?: boolean): void {
        console.log('%c ### tryMove tween start', 'color: #f0f', performance.now());
        const tweenOn = true;
        const tweenCard = (card: any, x: number, y: number) => {
            this.isAnimating = true;
            card.tweener.addTween({x: x, y: y}, 600, () => {
                if (tweenOn) {
                    card.parentPile?.moveRest(x, y);
                    card.parentPile?.showRest(true);
                }
                this.isAnimating = false;
                console.log('%c ### tryMove tween complete', 'color: #f0f', performance.now());
            });
        };
        const tweenCardId = (id: number | string, x: number, y: number) => {
            if (this.pileMap.has(id)) {
                let card = this.pileMap.get(id) as PixiCard;
                if (card && card.closeMenu) {
                    card.closeMenu();
                    card.closeMenu = null;
                }
                let viewPosition = this.getViewPosition(card, x, y);
                this.moveToTop(card);
                let samePos = (Math.abs(card.x - viewPosition.x) < 1 && Math.abs(card.y - viewPosition.y) < 1);
                if (tweenOn) {
                    card.parentPile?.showRest(samePos);
                    tweenCard(card as any, viewPosition.x, viewPosition.y);
                } else {
                    card.x = viewPosition.x;
                    card.y = viewPosition.y;
                    card.moveRest(card.x, card.y);
                }
            }
        };
        diffData.filter(it => !!it).forEach((it: CardPositionDiff, i: number) => {
            tweenCardId(it.id, it.x, it.y);
        });
    }

    /**
     * Получить стопку по id
     * @param id
     * @private
     */
    private getPileById(id: number): PixiCard {
        return this.pileMap.get(id);
    }

    /**
     * Подсвечиваем вновь добавленную стопку цветом игрока, который добавил ее
     */
    private signalCardAdditionByPlayer(stackId: number, playerId: string): void {
        const currentPlayerId = store.getters.getPlayerId;
        if (currentPlayerId !== playerId) {
            PixiUtil.delay(30).then(() => {
                if (this.pileMap.has(stackId)) {
                    const card = this.getPileById(stackId);
                    const players = store.getters.getPlayers;
                    const player: Player = (Object.values(players) as Array<Player>)
                        .find((value: Player) => value.id === playerId) as Player;
                    if (player && player.color.code) {
                        const color = parseInt(player.color.code.slice(1), 16);
                        const outline = new OutlineFilter(4, color);
                        card.setFilter(outline, true);
                    }
                    PixiUtil.delay(2000).then(() => {
                        card.resetFilter();
                    });
                }
            });
        }
    }

    /**
     * Обработка неверного хода
     */
    private wrongMove(): void {
        this.handContainer.showCards();
        this.handContainer.showHandBorder(true);
        setTimeout(() => this.handContainer.showHandBorder(false), 500);
        if (this.hoverTargetT) {
            let x = this.hoverTargetT.x, y = this.hoverTargetT.y;
            this.hoverTargetT.y -= 30;
            (this.hoverTargetT as PixiCard).tweener.addWrongMoveTween({x: x, y: y}, 200, () => {
                this.hoverTargetT = null;
            });
        }
    }

    /**
     * Начать обновление карт на столе
     */
    private refreshGameField(): void {
        if (this.mustUpdate && this.rect) {
            this.mustUpdate = false;
            return;
        }
        this.finishGameField();
    }

    /**
     * Координаты: Вид -> Модель
     */
    private getModelPosition(card: PixiCard): IPosition {
        if (!card || !card.getAttrs()) {
            throw new Error('Card has no attributes!');
        }
        const attrs = card.getAttrs();
        return {
            cardId: attrs.cardId,
            pileId: attrs.pileId,
            x: card.x - attrs.width / 2,
            y: card.y - attrs.height / 2,
            zone: attrs.zone
        };
    }

    /**
     * Координаты: Модель -> Вид
     */
    private getViewPosition(card: PixiCard, x: number, y: number): IPosition {
        if (!card || !card.getAttrs()) {
            throw new Error('Card has no attributes!');
        }
        const attrs = card.getAttrs();
        return {
            cardId: attrs.cardId,
            pileId: attrs.id,
            x: x + attrs.width / 2,
            y: y + attrs.height / 2,
            zone: attrs.zone
        };
    }

    /**
     * Создание пачки из конфига
     */
    private createPile(pileConf: IPileM): GameObject {
        return PixiPile.create(pileConf, this);
    }

    /**
     * Управление слайдером руки
     */
    private handleArrows(value: number): void {
        if (this.isBanned('canTablePreviewCards')) {
            return;
        }
        this.cardHandIndex = value < 0 ?
            this.handContainer.getPrevIdx(this.cardHandIndex) :
            this.handContainer.getNextIdx(this.cardHandIndex);
        const card = this.handContainer.getCardByIdx(this.cardHandIndex);
        if (card) {
            EventApi.triggerEvent(EventApi.ZOOM_ITEMS, [card.cardSrc]);
        }
    }

    /**
     * Перевернуть пачки
     */
    private flipPilesOld(list: Array<number>, mustRecreate = false): boolean {
        const cardList = list.map((id) => {
            if (this.pileMap.has(id)) {
                return this.pileMap.get(id) as PixiCard;
            }
            return null;
        });
        return this.flipList(cardList, [], mustRecreate);
    }

    private flipPiles(list: Array<{id: number, flipped: boolean}>, mustRecreate = false): boolean {
        const cardList = list.map((it) => {
            if (this.pileMap.has(it.id)) {
                return this.pileMap.get(it.id) as PixiCard;
            }
            return null;
        });
        const flippedList = list.map((it) => {
            if (this.pileMap.has(it.id)) {
                return it.flipped;
            }
            return false;
        });
        return this.flipList(cardList, flippedList, mustRecreate);
    }

    private flipList(cardList: Array<PixiCard | null>, flippedList: Array<boolean>, mustRecreate = false): boolean {
        cardList.forEach((card, i) => {
            if (card) {
                const angle = card.angle;
                const recreate = () => {
                    if (mustRecreate) {
                        const flipTopCard = this.recreatePileById(card.pileId);
                        if (flipTopCard) {
                            flipTopCard.angle = angle;
                        }
                    }
                };
                if (!card.tweener.flipping) {
                    card.flipAnim(flippedList[i], this.soloDrag, recreate);
                }
            }
        });
        return true;
    }

    /**
     * Перевернуть карты
     */
    private flipCards(list: Array<number>): boolean {
        const cardList = list.map((id) => {
            let card = this.handContainer.getCard(id);
            return card ?? null;
        });

        const isAnimating = cardList.some((card) => card && card.isAnimatingNow);
        if (isAnimating) {
            return false;
        }

        cardList.forEach((card) => {
            if (card) {
                card.flipAnim();
            }
        });
        return true;

        // list.forEach((id) => {
        //     let card = this.handContainer.getCard(id);
        //     card?.flipAnim();
        // });
    }

    /**
     * Перемешать пачки
     */
    private shufflePilesById(list: Array<number>): void {
        list.forEach(id => {
            const pileConf = this.modelState.getPile(id);
            if (id && pileConf && pileConf.cards?.length > 1) {
                this.deletePileById(id);
                const pile = this.createPile(pileConf) as PixiPile;
                pile.blurRest(false);
                pile.topCard.tweener.addShuffleTween();
            }
        });
    }

    /**
     * Переключить интерактивность
     * @param card
     * @param value
     */
    private toggleBlock(card: PixiCard, value: boolean) {
        card.interactive = value;
        card.buttonMode = value;
    }

    /**
     * Захватить пачки на столе
     */
    private seizePiles(list: Array<{id: number, usedByPlayer: string, blockedByPlayer: string}>): void {
        list.forEach(pile => {
            let topCard = this.pileMap.get(pile.id) as PixiCard;
            if (topCard.pileId === this.pieMenu?.ownerId && pile.usedByPlayer !== this.playerId) {
                this.pieMenu?.closeMenu();
            }
            if (topCard.tweener.tweening) {
                topCard.tweener.addCallback(() => {
                    topCard.parentPile?.setUsedByPlayer(pile.usedByPlayer, pile.blockedByPlayer);
                });
            } else {
                topCard.parentPile?.setUsedByPlayer(pile.usedByPlayer, pile.blockedByPlayer);
            }
        });
    }

    /**
     * Обновление по диффу
     */
    private diffUpdate(): void {
        const diff = this.modelState.diff;
        // console.log('%c ### ::DIFF::', 'color: #f0f', diff);
        let result = '';

        /**
         * Перенос стопки со стола в руку
         */
        if (diff.handCreate.length > 0) {
            const index = this.modelState.getCardIndex(diff.handCreate[0].id);
            const cardIndexes = this.handContainer.getCardIds();
            diff.handCreate.forEach(card => {
                if (!cardIndexes.includes(card.id)) {
                    this.createHandCard(card, index);
                }
            });
            this.handContainer.updateHand();
        }

        if (diff.pilesDelete.length > 0) {
            result += ' Delete: ' + diff.pilesDelete.length;
            diff.pilesDelete.forEach(pile => this.deletePileById(pile.id));
        }

        if (diff.pilesUpdate.length > 0) {
            result += ' Update: ' + diff.pilesUpdate.length;

            if (this.NEW_DIFF_ON) {
                const state = this.modelState;

                const sizeList = state.sizeList;
                if (sizeList.length > 0) {
                    for (const pile of sizeList) {
                        let card = this.pileMap.get(pile.id) as PixiCard;
                        if (card && card.closeMenu) {
                            card.closeMenu();
                            card.closeMenu = null;
                        }
                        this.deletePileById(pile.id);
                        this.createPile(pile);
                    }
                }

                const angleList = state.angleList;
                if (angleList.length > 0) {
                    for (const value of angleList) {
                        if (this.pileMap.has(value.id)) {
                            let card = this.pileMap.get(value.id) as PixiCard;
                            card.rotate(value.angle, false);
                        }
                    }
                }

                const lockList = state.lockList;
                if (lockList.length > 0) {
                    for (const value of lockList) {
                        if (this.pileMap.has(value.id)) {
                            let card = this.pileMap.get(value.id) as PixiCard;
                            card.locked = value.locked;
                        }
                    }
                }

                const moveList = state.moveList;
                if (moveList.length > 0) {
                    this.movePiles(moveList);
                }

                const dragFlip = state.getDragFlip();
                const flipList = state.flipList;
                if (flipList.length > 0) {
                    if (dragFlip) {
                        flipList.forEach(it => {
                            this.recreatePileById(it.id);
                        });
                    } else {
                        this.flipPiles(flipList, true);
                    }
                }

                const usedList = state.usedList;
                if (usedList.length > 0) {
                    this.seizePiles(usedList);
                }

                const shuffledList = state.shuffledList;
                if (shuffledList.length > 0) {
                    this.shufflePilesById(shuffledList);
                }
            }
        }

        if (diff.pilesCreate.length > 0) {
            this.modelState.flipList;
            result += ' Create: ' + diff.pilesCreate.length;
            diff.pilesCreate.forEach(pileConf => {
                const pile = PixiPile.create(pileConf, this);
                // if (pileConf.flipped) {
                //     pile.topCard.wait();
                // }
            });
        }

        // if (result && this.NEW_DIFF_ON) {
        //     console.log('%c ### [DIFF]', 'color: #f0f', result);
        // }

        setTimeout(() => {
            if (this.clonedCards.length) {
                this.clonedCards.forEach(cloneCard => {
                    cloneCard?.parent?.removeChild(cloneCard);
                });
                this.clonedCards = [];
            }
            // this.handContainer.showCards();
        }, 0);
    }

    /**
     * Для отладки
     */
    private pileToTableTest(keyTarget: PixiCard) {
        // console.log('%c ### --- --- Key Up:', 'color: #f0f', 'P:', keyTarget.pileId, 'C:', keyTarget.cardId);
        setInterval(() => {
            let pile = this.getPileById(keyTarget.pileId).parentPile;
            // console.log('%c ### --- ---', 'color: #f0f', pile?.topCard.cardId, pile?.cardListLength, pile?.cardListInfo);
            if ((pile?.cardListLength ?? 0) > 1) {
                let topCard = pile?.topCard;
                if (topCard) {
                    MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_ON_TABLE, {
                        x: topCard.x + topCard.size.width,
                        y: topCard.y + topCard.size.height,
                        id: topCard.cardId,
                        flip: true
                    });
                }
            }
        }, 2000);
    }

}
